import { createContext } from 'react';

export type CustomSearchExtensionPropsContextType = {
	advancedSearchUrl: string;
	cloudId: string;
	displayName: string;
	getSpaceIdsFromSpaceKeys: (spaceKeys: string[]) => Promise<string[]>;
	isAdminHubAIEnabled: boolean;
	orgId: string;
	peopleDirectoryUrl: string;
	push: (url: string) => void;
	userId: string;
};

const defaultContext: CustomSearchExtensionPropsContextType = {
	advancedSearchUrl: '',
	cloudId: '',
	displayName: '',
	getSpaceIdsFromSpaceKeys: async () => [],
	isAdminHubAIEnabled: false,
	orgId: '',
	peopleDirectoryUrl: '',
	push: () => {},
	userId: '',
};

export const CustomSearchExtensionPropsContext =
	createContext<CustomSearchExtensionPropsContextType>(defaultContext);
